import React, { useState } from 'react';

function Contatti() {
  const [form, setForm] = useState({
    nome: '',
    email: '',
    messaggio: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const mailtoLink = `mailto:fantafwi@gmail.com?subject=Contatto%20dal%20sito&body=Nome: ${form.nome}%0AEmail: ${form.email}%0AMessaggio: ${form.messaggio}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="container py-5">
      <h1 className="mb-4">Contattaci</h1>
      <p>Per qualsiasi domanda, dubbio o suggerimento, puoi usare uno di questi metodi:</p>

      <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-4">
        <a
          href="https://www.instagram.com/fanta.wrestling/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-primary d-flex align-items-center gap-2"
        >
          <i className="bi bi-instagram"></i> Instagram
        </a>
        <a
          href="https://t.me/fantawrestlingchat"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-info d-flex align-items-center gap-2"
        >
          <i className="bi bi-telegram"></i> Telegram
        </a>
        <a
          href="mailto:fantafwi@gmail.com"
          className="btn btn-outline-dark d-flex align-items-center gap-2"
        >
          <i className="bi bi-envelope"></i> Email
        </a>
      </div>

      <p>Oppure compila il modulo qui sotto:</p>

      <form onSubmit={handleSubmit} className="mt-4">
        <div className="mb-3">
          <label htmlFor="nome" className="form-label">Nome</label>
          <input type="text" className="form-control" id="nome" name="nome" value={form.nome} onChange={handleChange} required />
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" className="form-control" id="email" name="email" value={form.email} onChange={handleChange} required />
        </div>

        <div className="mb-3">
          <label htmlFor="messaggio" className="form-label">Messaggio</label>
          <textarea className="form-control" id="messaggio" name="messaggio" rows="4" value={form.messaggio} onChange={handleChange} required></textarea>
        </div>

        <button type="submit" className="btn btn-warning fw-bold">Invia</button>
      </form>
    </div>
  );
}

export default Contatti;
